export const GET_AI_CHAT_TOKEN_REQUEST = 'GET_AI_CHAT_TOKEN_REQUEST';
export const GET_AI_CHAT_TOKEN_DONE = 'GET_AI_CHAT_TOKEN_DONE';
export const GET_AI_CHAT_TOKEN_FAILED = 'GET_AI_CHAT_TOKEN_FAILED';
export const CLEAR_AI_CHAT_TOKEN = 'CLEAR_AI_CHAT_TOKEN';
